import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function About() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const aboutSchema = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "关于黑料吃瓜",
      description: "黑料吃瓜是一个娱乐八卦短视频平台，提供最新明星八卦、网红爆料、娱乐内幕等内容。",
      url: "https://wx1121.cn/about",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "首页",
          item: "https://wx1121.cn/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "关于我们",
        },
      ],
    },
  ];

  return (
    <>
      <SEO
        title="关于我们 - 黑料吃瓜"
        description="了解黑料吃瓜平台的品牌故事、平台优势、用户口碑和联系方式。黑料吃瓜致力于为用户提供最新最热的娱乐八卦视频内容。"
        keywords="黑料吃瓜关于我们,黑料吃瓜简介,黑料吃瓜联系方式"
        canonicalUrl="https://wx1121.cn/about"
        schema={aboutSchema}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-16">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />

            {/* Hero */}
            <section className="text-center py-12 md:py-16">
              <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-6">
                关于<span className="text-primary-500">黑料吃瓜</span>
              </h1>
              <p className="text-base text-foreground-500 max-w-3xl mx-auto leading-relaxed">
                黑料吃瓜是一个专注于娱乐八卦内容的短视频平台，致力于为全网用户提供最新、最热、最全的吃瓜视频内容。
                我们每日更新，涵盖明星八卦、网红爆料、娱乐内幕、饭圈撕逼等多个热门分类，让每一位用户都能在这里找到自己感兴趣的吃瓜内容。
              </p>
            </section>

            {/* Stats */}
            <section className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
              {[
                { value: "10万+", label: "日活用户" },
                { value: "5000+", label: "视频内容" },
                { value: "8大", label: "热门分类" },
                { value: "99.9%", label: "服务稳定性" },
              ].map((stat, i) => (
                <div
                  key={i}
                  className="text-center p-6 rounded-xl bg-background-100"
                >
                  <p className="text-2xl md:text-3xl font-heading text-primary-500">
                    {stat.value}
                  </p>
                  <p className="text-sm text-foreground-500 mt-2">{stat.label}</p>
                </div>
              ))}
            </section>

            {/* Brand Story */}
            <section className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">
                品牌<span className="text-primary-500">故事</span>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4 text-foreground-600 text-sm leading-relaxed">
                  <p>
                    黑料吃瓜成立于2024年，由一群热爱娱乐八卦的年轻人创建。我们发现，虽然社交平台上充斥着各种娱乐信息，但用户往往需要在多个平台之间切换才能获取完整的信息。
                  </p>
                  <p>
                    于是，我们决定打造一个专注于娱乐八卦内容聚合的平台——黑料吃瓜。我们汇集全网最新最热的明星八卦、网红爆料、娱乐内幕，以高清视频的形式呈现，为用户提供一站式吃瓜体验。
                  </p>
                  <p>
                    如今，黑料吃瓜已经成为国内领先的娱乐短视频平台之一，每天服务超过10万活跃用户，内容库超过5000条视频，涵盖8大热门分类。
                  </p>
                </div>
                <div className="rounded-xl overflow-hidden aspect-video">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20media%20office%20with%20young%20Chinese%20team%20collaborating%2C%20warm%20lighting%2C%20creative%20workspace%2C%20large%20screens%20displaying%20video%20content%2C%20contemporary%20interior%2C%20vibrant%20atmosphere%2C%20professional%20yet%20relaxed%20environment&width=800&height=450&seq=about-brand&orientation=landscape"
                    alt="黑料吃瓜团队"
                    title="黑料吃瓜 - 我们的团队"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </section>

            {/* Advantages */}
            <section className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">
                平台<span className="text-primary-500">优势</span>
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {[
                  {
                    icon: "ri-flashlight-line",
                    title: "实时更新",
                    desc: "全天候监控娱乐动态，第一时间发布最新吃瓜内容，让你永远走在八卦最前沿。",
                  },
                  {
                    icon: "ri-hd-line",
                    title: "高清画质",
                    desc: "所有视频均采用高清画质，支持在线流畅播放，带来极致的观看体验。",
                  },
                  {
                    icon: "ri-layout-grid-line",
                    title: "丰富分类",
                    desc: "8大热门分类，涵盖明星八卦、综艺剧幕、饭圈撕逼等多种内容类型。",
                  },
                  {
                    icon: "ri-smartphone-line",
                    title: "多端兼容",
                    desc: "支持PC端和移动端访问，随时随地观看精彩内容。",
                  },
                  {
                    icon: "ri-shield-check-line",
                    title: "内容审核",
                    desc: "严格的内容审核机制，确保内容真实可靠，拒绝虚假信息和恶意造谣。",
                  },
                  {
                    icon: "ri-user-heart-line",
                    title: "用户至上",
                    desc: "以用户需求为导向，持续优化产品体验，打造最懂吃瓜群众的平台。",
                  },
                ].map((adv, i) => (
                  <div key={i} className="p-6 rounded-xl bg-background-100">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4">
                      <i className={`${adv.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-2">
                      {adv.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{adv.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Reputation */}
            <section className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">
                用户<span className="text-primary-500">口碑</span>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    name: "吃瓜群众小王",
                    role: "忠实用户",
                    comment:
                      "自从发现了黑料吃瓜，每天上班摸鱼都有好东西看了！更新速度超快，视频画质也很好，强烈推荐！",
                    rating: 5,
                  },
                  {
                    name: "娱乐圈观察员",
                    role: "资深用户",
                    comment:
                      "内容分类很清晰，想看什么类型的八卦都能快速找到。比在其他平台翻来翻去方便多了。",
                    rating: 5,
                  },
                  {
                    name: "瓜田里的猹",
                    role: "活跃用户",
                    comment:
                      "每天必刷的网站！热恋吃瓜和饭圈撕逼是我最爱的分类，希望平台越做越好！",
                    rating: 4,
                  },
                ].map((review, i) => (
                  <div key={i} className="p-6 rounded-xl bg-background-100">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, j) => (
                        <i
                          key={j}
                          className={`text-sm ${
                            j < review.rating
                              ? "ri-star-fill text-accent-500"
                              : "ri-star-line text-foreground-300"
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      "{review.comment}"
                    </p>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                      <p className="text-xs text-foreground-400">{review.role}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section className="mb-16 p-8 md:p-10 rounded-xl bg-background-100">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">
                联系<span className="text-primary-500">我们</span>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                    <p className="text-sm text-foreground-500">contact@heiliaochigua.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h4>
                    <p className="text-sm text-foreground-500">北京市朝阳区光华路 科技大厦18层</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-phone-line"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">客服电话</h4>
                    <p className="text-sm text-foreground-500">400-888-8888</p>
                    <p className="text-xs text-foreground-400 mt-1">工作日 9:00 - 18:00</p>
                  </div>
                </div>
              </div>
            </section>

            {/* CTA */}
            <div className="text-center">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line"></i>
                返回首页开始吃瓜
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}